import { ICorrection, IMeetingSession } from '../interfaces/event';

export const sortASCTime = (array: Array<IMeetingSession | ICorrection>): Array<IMeetingSession | ICorrection> => {
  return array.sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime());
};
